// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
import { useHomeText } from '../text';

const Pedagogy = () => {
  const t = useHomeText();
  return (
    <section id="pedagogy" style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 24px 0", display: "flex", flexDirection: "column", gap: "48px" }}>
      <section id="features" style={{ background: "#FFFFFF", borderTop: "1px solid #E1E5F7", borderBottom: "1px solid #E1E5F7" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "56px 24px 104px", display: "flex", flexDirection: "column", gap: "40px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "center", textAlign: "center" }}>
            <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
              {t.pedagogy.features}
            </span>
            <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2" }}>
              {t.pedagogy.whyDoParentsAnd}
            </h2>
          </div>
          <div role="tablist" aria-label={t.pedagogy.featuresLabel} style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
            <button type="button" role="tab" id="kh-tab-0" aria-controls="kh-panel-0" aria-selected="true" data-tab="0" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #141C63", background: "#141C63", color: "#FFFFFF" }}>
              {t.pedagogy.contentAlignedWithThe}
            </button>
            <button type="button" role="tab" id="kh-tab-1" aria-controls="kh-panel-1" aria-selected="false" data-tab="1" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #E1E5F7", background: "#FFFFFF", color: "#121A4A" }}>
              {t.pedagogy.overcomingLearningDifficulties}
            </button>
            <button type="button" role="tab" id="kh-tab-2" aria-controls="kh-panel-2" aria-selected="false" data-tab="2" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #E1E5F7", background: "#FFFFFF", color: "#121A4A" }}>
              {t.pedagogy.augmentedReality}
            </button>
            <button type="button" role="tab" id="kh-tab-3" aria-controls="kh-panel-3" aria-selected="false" data-tab="3" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #E1E5F7", background: "#FFFFFF", color: "#121A4A" }}>
              {t.pedagogy.bloomSTaxonomyOf}
            </button>
            <button type="button" role="tab" id="kh-tab-4" aria-controls="kh-panel-4" aria-selected="false" data-tab="4" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #E1E5F7", background: "#FFFFFF", color: "#121A4A" }}>
              {t.pedagogy.whatKhotouaOffersParents}
            </button>
          </div>
          <div className="kh-panel" id="kh-panel-0" role="tabpanel" aria-labelledby="kh-tab-0" data-panel="0">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                  01
                </span>
                <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "34px", lineHeight: "1.3" }}>
                  {t.pedagogy.yourChildPlaysAnd}
                </h3>
                <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                  {t.pedagogy.allSubjectsFollowThe}
                </p>
                <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                  {t.pedagogy.behindEveryPieceOf}
                </p>
                <strong style={{ alignSelf: "flex-start", padding: "10px 18px", borderRadius: "16px", background: "#FFC93C", color: "#0B1240", fontSize: "19px" }}>
                  {t.pedagogy.screenTimeBecomesTime}
                </strong>
              </div>
              <div className="kh-fit" style={{ boxSizing: "border-box", minWidth: "0", display: "flex", justifyContent: "center" }}>
                <div className="kh-fit-inner" style={{ boxSizing: "border-box", width: "460px", flex: "none" }}>
                  <div style={{ background: "#FFC93C", borderRadius: "36px", padding: "40px", display: "flex", flexDirection: "column", gap: "18px", position: "relative", overflow: "hidden", height: "420px", justifyContent: "flex-end" }}>
                    <img width="432" height="578" loading="lazy" decoding="async" src="/assets/img/boy-cheer.webp" alt="" style={{ position: "absolute", top: "-21px", left: "-32px", width: "300px", height: "auto" }} />
                    <h2 style={{ position: "relative", margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "44px", lineHeight: "1.2", color: "#0B1240", maxWidth: "420px", width: "303px" }}>
                      {t.pedagogy.usefulScreenTimeWith}
                    </h2>
                    <span style={{ position: "relative", fontWeight: "800", fontSize: "15px", color: "#6E4A00" }}>
                      {t.pedagogy.parentSpace}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="kh-panel" id="kh-panel-1" role="tabpanel" aria-labelledby="kh-tab-1" data-panel="1" hidden>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                  02
                </span>
                <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "34px", lineHeight: "1.3" }}>
                  {t.pedagogy.khotouaYourChildS}
                </h3>
                <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                  {t.pedagogy.khotouaStandsOutFor}
                </p>
                <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                  {t.pedagogy.weKeepImprovingKhotoua}
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <svg viewBox="0 0 400 420" width="360" style={{ maxWidth: "100%", height: "auto" }} role="img" aria-label={t.pedagogy.overcomingDifficultiesIconColouredLabel}>
                  <defs>
                    <linearGradient id="khDifBg" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0" stopColor="#4FE0CA" />
                      <stop offset="1" stopColor="#169A8A" />
                    </linearGradient>
                    {" "}
                    <pattern id="khDifDots" width="22" height="22" patternUnits="userSpaceOnUse">
                      <circle cx="4" cy="4" r="2" fill="#FFFFFF" fillOpacity="0.22" />
                    </pattern>
                  </defs>
                  {" "}
                  <rect x="0" y="18" width="400" height="400" rx="84" fill="#0E6E63" />
                  {" "}
                  <rect x="0" y="0" width="400" height="400" rx="84" fill="url(#khDifBg)" />
                  {" "}
                  <rect x="0" y="0" width="400" height="400" rx="84" fill="url(#khDifDots)" />
                  {" "}
                  <path d="M60 40 h280 a60 60 0 0 1 40 18 c-90 -10 -250 -10 -360 0 a60 60 0 0 1 40 -18z" fill="#FFFFFF" fillOpacity="0.25" />
                  {" "}
                  <rect x="272" y="270" width="76" height="70" rx="14" fill="#C48E00" />
                  <rect x="272" y="262" width="76" height="70" rx="14" fill="#FFC93C" />
                  {" "}
                  <rect x="190" y="210" width="76" height="130" rx="14" fill="#C96A12" />
                  <rect x="190" y="202" width="76" height="130" rx="14" fill="#FF9A3D" />
                  {" "}
                  <rect x="108" y="150" width="76" height="190" rx="14" fill="#B2357F" />
                  <rect x="108" y="142" width="76" height="190" rx="14" fill="#F27DC2" />
                  {" "}
                  <rect x="26" y="90" width="76" height="250" rx="14" fill="#5A3FC0" />
                  <rect x="26" y="82" width="76" height="250" rx="14" fill="#A58BFF" />
                  {" "}
                  <text x="310" y="306" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="30" fill="#0B1240">
                    1
                  </text>
                  {" "}
                  <text x="228" y="246" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="30" fill="#0B1240">
                    2
                  </text>
                  {" "}
                  <text x="146" y="186" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="30" fill="#0B1240">
                    3
                  </text>
                  {" "}
                  <text x="64" y="126" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="30" fill="#0B1240">
                    4
                  </text>
                  {" "}
                  <path d="M330 236 C 300 200, 260 190, 236 176 S 180 130, 154 118 S 100 66, 74 56" fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeDasharray="2 14" />
                  {" "}
                  <path d="M64 14 l9 20 22 3 -16 15 4 22 -19 -11 -19 11 4 -22 -16 -15 22 -3z" fill="#FFC93C" stroke="#FFFFFF" strokeWidth="4" strokeLinejoin="round" />
                  {" "}
                  <path d="M338 224 c-8 -10 -24 -6 -24 7 0 12 24 26 24 26 s24 -14 24 -26 c0 -13 -16 -17 -24 -7z" fill="#FFFFFF" />
                </svg>
              </div>
            </div>
          </div>
          <div className="kh-panel" id="kh-panel-2" role="tabpanel" aria-labelledby="kh-tab-2" data-panel="2" hidden>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                  03
                </span>
                <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "34px", lineHeight: "1.3" }}>
                  {t.pedagogy.theLessonLeavesThe}
                </h3>
                <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                  {t.pedagogy.withAugmentedRealityLearning}
                </p>
                <strong style={{ alignSelf: "flex-start", padding: "10px 18px", borderRadius: "16px", background: "#F27DC2", color: "#3D0A28", fontSize: "19px" }}>
                  {t.pedagogy.becauseWhatChildrenLive}
                </strong>
              </div>
              <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-encyclopedia.webp" alt={t.pedagogy.myEncyclopediaScreenInAlt} style={{ width: "100%", display: "block", borderRadius: "24px", boxShadow: "0 20px 40px rgba(20,28,99,0.18)", transform: "rotate(-9deg)" }} />
            </div>
          </div>
          <div className="kh-panel" id="kh-panel-3" role="tabpanel" aria-labelledby="kh-tab-3" data-panel="3" hidden>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                  04
                </span>
                <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "30px", lineHeight: "1.35" }}>
                  {t.pedagogy.learningContentIsBuilt}
                </h3>
                <ol style={{ margin: "0", padding: "0", listStyle: "none", display: "flex", flexDirection: "column", gap: "10px" }}>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#46D3BE", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                      1
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      {t.pedagogy.theLearnerExploresKnowledge}
                    </span>
                  </li>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#6FA8FF", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                      2
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      {t.pedagogy.practisesActivitiesThatEnsure}
                    </span>
                  </li>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#FFC93C", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                      3
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      {t.pedagogy.appliesWhatTheyHave}
                    </span>
                  </li>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#FF9A3D", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                      4
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      {t.pedagogy.analysesTheKnowledgeAnd}
                    </span>
                  </li>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#F27DC2", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                      5
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      {t.pedagogy.evaluatesWhatTheyHave}
                    </span>
                  </li>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#FFFFFF", border: "2px solid #A58BFF", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                      6
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      {t.pedagogy.inventsAndCreatesA}
                    </span>
                  </li>
                </ol>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <svg viewBox="0 0 400 420" width="380" style={{ maxWidth: "100%", height: "auto" }} role="img" aria-label={t.pedagogy.bloomSTaxonomyIconLabel}>
                  <defs>
                    <linearGradient id="khBloomBg" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0" stopColor="#8C6CFF" />
                      <stop offset="1" stopColor="#3B2F9F" />
                    </linearGradient>
                    {" "}
                    <pattern id="khBloomDots" width="22" height="22" patternUnits="userSpaceOnUse">
                      <circle cx="4" cy="4" r="2" fill="#FFFFFF" fillOpacity="0.18" />
                    </pattern>
                  </defs>
                  {" "}
                  <rect x="0" y="18" width="400" height="400" rx="84" fill="#271E78" />
                  {" "}
                  <rect x="0" y="0" width="400" height="400" rx="84" fill="url(#khBloomBg)" />
                  {" "}
                  <rect x="0" y="0" width="400" height="400" rx="84" fill="url(#khBloomDots)" />
                  {" "}
                  <path d="M60 40 h280 a60 60 0 0 1 40 18 c-90 -10 -250 -10 -360 0 a60 60 0 0 1 40 -18z" fill="#FFFFFF" fillOpacity="0.2" />
                  {" "}
                  <g transform="translate(0,6)" fill="#000000" fillOpacity="0.22">
                    <polygon points="50,330 350,330 333.1,290 66.9,290" />
                    <polygon points="68.6,286 331.4,286 314.5,246 85.5,246" />
                    <polygon points="87.2,242 312.8,242 295.8,202 104.2,202" />
                    <polygon points="105.8,198 294.2,198 277.2,158 122.8,158" />
                    <polygon points="124.5,154 275.5,154 258.6,114 141.4,114" />
                    <polygon points="143.1,110 256.9,110 240,70 160,70" />
                  </g>
                  {" "}
                  <polygon points="50,330 350,330 333.1,290 66.9,290" fill="#46D3BE" />
                  {" "}
                  <polygon points="68.6,286 331.4,286 314.5,246 85.5,246" fill="#6FA8FF" />
                  {" "}
                  <polygon points="87.2,242 312.8,242 295.8,202 104.2,202" fill="#FFC93C" />
                  {" "}
                  <polygon points="105.8,198 294.2,198 277.2,158 122.8,158" fill="#FF9A3D" />
                  {" "}
                  <polygon points="124.5,154 275.5,154 258.6,114 141.4,114" fill="#F27DC2" />
                  {" "}
                  <polygon points="143.1,110 256.9,110 240,70 160,70" fill="#FFFFFF" />
                  {" "}
                  <g fontFamily="'Baloo Bhaijaan 2', 'IBM Plex Sans Arabic', sans-serif" fontWeight="800" fontSize="21" fill="#0B1240" textAnchor="middle" direction="rtl">
                    <text x="200" y="317">
                      {t.pedagogy.remember}
                    </text>
                    {" "}
                    <text x="200" y="273">
                      {t.pedagogy.understand}
                    </text>
                    {" "}
                    <text x="200" y="229">
                      {t.pedagogy.apply}
                    </text>
                    {" "}
                    <text x="200" y="185">
                      {t.pedagogy.analyse}
                    </text>
                    {" "}
                    <text x="200" y="141">
                      {t.pedagogy.evaluate}
                    </text>
                    {" "}
                    <text x="200" y="97" fill="#3B2F9F">
                      {t.pedagogy.create}
                    </text>
                  </g>
                  {" "}
                  <path d="M200 22 l6 14 15 2 -11 10 3 15 -13 -8 -13 8 3 -15 -11 -10 15 -2z" fill="#FFC93C" stroke="#FFFFFF" strokeWidth="3" strokeLinejoin="round" />
                  {" "}
                  <text x="200" y="378" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="26" fill="#FFFFFF" direction="rtl">
                    {t.pedagogy.bloomSTaxonomy}
                  </text>
                </svg>
              </div>
            </div>
          </div>
          <div className="kh-panel" id="kh-panel-4" role="tabpanel" aria-labelledby="kh-tab-4" data-panel="4" hidden>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                  05
                </span>
                <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "32px", lineHeight: "1.3" }}>
                  {t.pedagogy.whatKhotouaOffersParents2}
                </h3>
                <p style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "700", fontSize: "22px", color: "#1E8F80" }}>
                  {t.pedagogy.youDonTNeed}
                </p>
                <ul style={{ margin: "0", padding: "0", listStyle: "none", display: "flex", flexDirection: "column", gap: "12px" }}>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#46D3BE", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", marginTop: "2px" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M5 12l5 5 9-10" />
                      </svg>
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      <strong>
                        {t.pedagogy.seeTheirProgress}
                      </strong>
                      {t.pedagogy.whatTheyHaveDone}
                    </span>
                  </li>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#46D3BE", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", marginTop: "2px" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M5 12l5 5 9-10" />
                      </svg>
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      <strong>
                        {t.pedagogy.trustEveryLesson}
                      </strong>
                      {t.pedagogy.contentAlignedWithThe2}
                    </span>
                  </li>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#46D3BE", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", marginTop: "2px" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M5 12l5 5 9-10" />
                      </svg>
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      <strong>
                        {t.pedagogy.followThemFromYour}
                      </strong>
                      {t.pedagogy.theParentSpaceBrings}
                    </span>
                  </li>
                  <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                    <span style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#46D3BE", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", marginTop: "2px" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M5 12l5 5 9-10" />
                      </svg>
                    </span>
                    <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                      <strong>
                        {t.pedagogy.peaceOfMindAbout}
                      </strong>
                      {t.pedagogy.aSafeSpaceDesigned}
                    </span>
                  </li>
                </ul>
                <strong style={{ alignSelf: "flex-start", padding: "10px 18px", borderRadius: "16px", background: "#141C63", color: "#FFFFFF", fontSize: "19px" }}>
                  {t.pedagogy.youLoveThemWe}
                </strong>
              </div>
              <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-profile.webp" alt={t.pedagogy.khotouaMyProfileAndAlt} style={{ width: "100%", display: "block", borderRadius: "24px", boxShadow: "0 20px 40px rgba(20,28,99,0.18)", transform: "rotate(-10deg)" }} />
            </div>
          </div>
        </div>
      </section>
      <div style={{ display: "flex", flexDirection: "column", gap: "16px", maxWidth: "900px" }}>
        <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
          {t.pedagogy.ourTeachingApproach}
        </span>
        <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2" }}>
          {t.pedagogy.variedLearningContent}
        </h2>
        <p style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "700", fontSize: "clamp(24px, 2.6vw, 32px)", lineHeight: "1.4", color: "#1E8F80" }}>
          {t.pedagogy.wePrepareYourChild}
        </p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(340px, 100%), 1fr))", gap: "20px" }}>
        <article style={{ background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "30px", display: "flex", flexDirection: "column", gap: "14px" }}>
          <span style={{ width: "64px", height: "64px", borderRadius: "20px", background: "#46D3BE", boxShadow: "0 6px 0 #1E8F80", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 6.500C5 5 8 5 12 7c4-2 7-2 9-.5V19c-2-1.500-5-1.500-9 .5-4-2-7-2-9-.5z" />
              <path d="M12 7v12.500" />
            </svg>
          </span>
          <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "24px" }}>
            {t.pedagogy.variedEducationalActivitiesAnd}
          </h3>
          <p style={{ margin: "0", fontSize: "17px", lineHeight: "1.85", color: "#3A4270" }}>
            {t.pedagogy.linkedToTheOfficial}
          </p>
        </article>
        <article style={{ background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "30px", display: "flex", flexDirection: "column", gap: "14px" }}>
          <span style={{ width: "64px", height: "64px", borderRadius: "20px", background: "#FFC93C", boxShadow: "0 6px 0 #C48E00", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 20s-7-4.400-7-10a4 4 0 0 1 7-2.600A4 4 0 0 1 19 10c0 5.600-7 10-7 10z" />
            </svg>
          </span>
          <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "24px" }}>
            {t.pedagogy.valuesToGrowUp}
          </h3>
          <p style={{ margin: "0", fontSize: "17px", lineHeight: "1.85", color: "#3A4270" }}>
            {t.pedagogy.citizenshipRespectForOthers}
          </p>
        </article>
        <article style={{ background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "30px", display: "flex", flexDirection: "column", gap: "14px" }}>
          <span style={{ width: "64px", height: "64px", borderRadius: "20px", background: "#A58BFF", boxShadow: "0 6px 0 #6A4FD0", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M3 12h18M12 3c3 3.500 3 14.500 0 18M12 3c-3 3.500-3 14.500 0 18" />
            </svg>
          </span>
          <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "24px" }}>
            {t.pedagogy.anEyeOnThe}
          </h3>
          <p style={{ margin: "0", fontSize: "17px", lineHeight: "1.85", color: "#3A4270" }}>
            {t.pedagogy.theyDiscoverTheIssues}
          </p>
        </article>
      </div>
      <blockquote style={{ margin: "0", background: "#141C63", color: "#FFFFFF", borderRadius: "28px", padding: "clamp(24px, 4vw, 40px)", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(24px, 2.8vw, 36px)", lineHeight: "1.4", textAlign: "center" }}>
        <span style={{ color: "#FFC93C" }}>
          {t.pedagogy.khotoua}
        </span>
        {t.pedagogy.yourChildSWindow}
      </blockquote>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "20px" }}>
        <article style={{ background: "#FFC93C", color: "#0B1240", borderRadius: "32px", padding: "36px", display: "flex", flexDirection: "column", gap: "16px", justifyContent: "center" }}>
          <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "32px", lineHeight: "1.3" }}>
            {t.pedagogy.joinUsTodayOn}
          </h3>
          <p style={{ margin: "0", fontSize: "17px", lineHeight: "1.9" }}>
            {t.pedagogy.helpYourChildrenDiscover}
          </p>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <a href="https://play.google.com/store/apps/details?id=com.DMNovaComany.Khotoua&pcampaignid=web_share" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", minHeight: "54px", padding: "0 22px", borderRadius: "18px", background: "#0B1240", color: "#FFFFFF", fontWeight: "800", textDecoration: "none" }}>
              {t.pedagogy.getTheAppNow}
            </a>
            <a href="https://khotoua.com/KHOTOUA_DEMO/Khotoua%20Inscription%20Portrait.dc.html" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", minHeight: "54px", padding: "0 22px", borderRadius: "18px", border: "2px solid #0B1240", color: "#0B1240", fontWeight: "800", textDecoration: "none" }}>
              {t.pedagogy.tryTheDemo}
            </a>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Pedagogy;
